import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/facebook-f.svg'
import _imports_1 from '@/assets/images/twitter.svg'
import _imports_2 from '@/assets/images/linkedin-in.svg'


const _hoisted_1 = { class: "lmd-footer" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "custom-row" }
const _hoisted_4 = { class: "footer-links" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"social-links\"><ul><li><a href=\"#\"><img src=\"" + _imports_0 + "\" alt=\"Facebook\"></a></li><li><a href=\"#\"><img src=\"" + _imports_1 + "\" alt=\"Facebook\"></a></li><li><a href=\"#\"><img src=\"" + _imports_2 + "\" alt=\"Facebook\"></a></li></ul></div><div class=\"copyright-text\"> 2025 LMD Consulting, LLC , All Rights Reserved </div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: `/privacy-policy`,
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.handleClick()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Privacy Policy")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: `/terms-condition`,
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.handleClick()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Terms & Conditions")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_5
      ])
    ])
  ]))
}